export enum Language {
  ARA = 'Arabic',
  BEN = 'Bengali',
  GER = 'German',
  GRE = 'Greek',
  ENG = 'English',
  SPA = 'Spanish',
  FRE = 'French',
  HEB = 'Hebrew',
  HIN = 'Hindi',
  ITA = 'Italian',
  JPN = 'Japanese',
  POL = 'Polish',
  POR = 'Portuguese',
  RUS = 'Russian',
  UKR = 'Ukrainian',
  URD = 'Urdu',
  CHI = 'Chinese',
  TUR = 'Turkish',
  KAZ = 'Kazakh',
}
